import { Fragment } from 'preact'

export const NonConformite = ({ details, nonComplianceComment }) => {
  return (
    <Fragment>
      <h3 class="h3 mb-1 mt-2">Non-conformités</h3>
      <div dangerouslySetInnerHTML={{ __html: nonComplianceComment }}></div>

      <p>Liste des critères <abbr lang="en" title="Web Content Accessibility Guidelines" style="speak: spell-out;">WCAG</abbr> non conformes&nbsp;:</p>
      <ul class="list">
        {Array.isArray(details.detail) ? (
          details.detail.map((detail) => {
            return <li>{detail.title}</li>
          })
        ) : (
          <li>{details.detail.title}</li>
        )}
      </ul>
    </Fragment>
  )
}
